angular.module('b2bLoginApp.controllers').controller('GoogleReviewsController', ["$scope", "$uibModal", "$http", "Notification", "TranslationService", function ($scope, $uibModal, $http, Notification, TranslationService) {

    var ERROR_TITLE_TRANSLATE = 'company-profile-public.google_reviews.error_title';
    var ERROR_TEXT_TRANSLATE = 'company-profile-public.google_reviews.error';

    var searchModal = null;
    var disconnectModal = null;

    $scope.places = [];
    $scope.selectedPlace = null;
    $scope.loadingPlaces = false;
    $scope.connecting = false;
    $scope.disconnecting = false;

    // ── GA4 Tracking Helpers ──

    function pushToDataLayer(eventData) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(eventData);
        } catch (e) { /* tracker not loaded */ }
    }

    function getCompanyId() {
        return $scope.company ? $scope.company.id : null;
    }

    function pushConnectFormInteraction(formInteraction, formStep, formStepName, displayValue) {
        var data = {
            event: 'form_interaction',
            form_name: 'connect_google_reviews',
            form_phase: 1,
            form_phase_name: 'choose_your_business',
            form_step: formStep,
            form_step_name: formStepName,
            form_total_phases: 1,
            form_total_steps: 2,
            form_interaction: formInteraction,
            company: { company_id: getCompanyId() }
        };
        if (displayValue) {
            data.display_value = displayValue;
        }
        pushToDataLayer(data);
    }

    function pushDisconnectFormInteraction(formInteraction) {
        pushToDataLayer({
            event: 'form_interaction',
            form_name: 'disconnect_google_reviews',
            form_phase: 1,
            form_phase_name: 'disconnect_google_reviews',
            form_step: 1,
            form_step_name: 'disconnect_google_reviews',
            form_total_phases: 1,
            form_total_steps: 1,
            form_interaction: formInteraction,
            company: { company_id: getCompanyId() }
        });
    }

    // ── End GA4 Tracking Helpers ──

    function googleReviews() {
        return $scope.data.profile.googleReviews;
    }

    function setGoogleReviews(googleReviewsData) {
        $scope.data.profile.googleReviews = googleReviewsData;
    }

    function notifyError(titleKey, textKey) {
        Notification.error(TranslationService.trans(titleKey), TranslationService.trans(textKey));
    }

    $scope.isGoogleConnected = function () {
        var reviews = googleReviews();

        return !!reviews && reviews.isConnected === true;
    };

    $scope.hasGoogleRating = function () {
        return $scope.isGoogleConnected() && !!googleReviews().userRatingCount;
    };

    $scope.selectPlace = function (place) {
        $scope.selectedPlace = place;
    };

    $scope.isSelected = function (place) {
        return $scope.selectedPlace === place;
    };

    $scope.foundPlaces = function () {
        return $scope.places.length > 0;
    };

    $scope.openSearchModal = function () {
        if ($scope.loadingPlaces) {
            return;
        }

        pushToDataLayer({
            event: 'form_start',
            form_name: 'connect_google_reviews',
            company: { company_id: getCompanyId() }
        });

        $scope.places = [];
        $scope.selectedPlace = null;
        $scope.loadingPlaces = true;
        $scope.connecting = false;

        searchModal = $uibModal.open({
            templateUrl: '/account/company-profile-public/google-places-search-modal.html',
            backdrop: 'static',
            scope: $scope
        });

        searchModal.result.then(null, function () {
            pushConnectFormInteraction('skip', 1, 'choose_your_business');
        });

        $http.post('google-reviews/search').then(function (response) {
            var places = (response.data && response.data.items) || [];

            $scope.places = places;
            $scope.selectedPlace = places.length ? places[0] : null;
            $scope.loadingPlaces = false;

            pushConnectFormInteraction('view', 1, 'choose_your_business', { num_matches: places.length });

            if (places.length === 0) {
                pushConnectFormInteraction('view', 2, 'no_results');
            }
        }, function () {
            closeSearchModal();
            notifyError(ERROR_TITLE_TRANSLATE, ERROR_TEXT_TRANSLATE);
        });
    };

    $scope.cancelSearch = function () {
        pushConnectFormInteraction('skip', 1, 'choose_your_business');
        closeSearchModal();
    };

    function closeSearchModal() {
        $scope.loadingPlaces = false;

        if (searchModal) {
            searchModal.close();
            searchModal = null;
        }
    }

    $scope.connect = function () {
        if (!$scope.selectedPlace || $scope.connecting) {
            return;
        }

        pushConnectFormInteraction('submit', 1, 'choose_your_business');

        $scope.connecting = true;

        $http.post('google-reviews/connect', {placeId: $scope.selectedPlace.placeId}).then(function (response) {
            setGoogleReviews(response.data.item);
            $scope.connecting = false;
            closeSearchModal();
            $scope.$root.$broadcast('profile:updated');
        }, function () {
            $scope.connecting = false;
            notifyError(ERROR_TITLE_TRANSLATE, ERROR_TEXT_TRANSLATE);
        });
    };

    $scope.openDisconnectModal = function () {
        pushToDataLayer({
            event: 'form_start',
            form_name: 'disconnect_google_reviews',
            company: { company_id: getCompanyId() }
        });

        $scope.disconnecting = false;

        disconnectModal = $uibModal.open({
            templateUrl: '/account/company-profile-public/google-reviews-disconnect-modal.html',
            backdrop: 'static',
            scope: $scope
        });

        pushDisconnectFormInteraction('view');
    };

    $scope.cancelDisconnect = function () {
        pushDisconnectFormInteraction('skip');
        if (disconnectModal) {
            disconnectModal.close();
            disconnectModal = null;
        }
    };

    $scope.disconnect = function () {
        if ($scope.disconnecting) {
            return;
        }

        pushDisconnectFormInteraction('submit');

        $scope.disconnecting = true;

        $http.post('google-reviews/disconnect').then(function () {
            setGoogleReviews({
                isConnected: false,
                rating: null,
                userRatingCount: null,
                googleMapsUri: null
            });
            $scope.disconnecting = false;

            if (disconnectModal) {
                disconnectModal.close();
                disconnectModal = null;
            }

            $scope.$root.$broadcast('profile:updated');
        }, function () {
            $scope.disconnecting = false;
            notifyError(ERROR_TITLE_TRANSLATE, ERROR_TEXT_TRANSLATE);
        });
    };
}]);
